import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import route_map from "@/config/route_map";
// import IndexRC from '@/pages/index';
import ErrorBoundary from "@/components/ErrorBoundary.js";
import LayoutRC from "@/components/layout";
// import AppTVRC from '@/pages/app_tv'
// import Labs from "./pages/labs";
import PageLoading from "@/components/pageLoading";
import { KNOWN_PATH_LANGS, buildLangPath } from "@/utils/langPath";

const IndexRC = React.lazy(() => import("@/pages/index"));
const Labs = React.lazy(() => import("./pages/labs"));
const NotFoundRC = React.lazy(() => import("@/pages/notFound"));

const withLanguages = (path, element) =>
  KNOWN_PATH_LANGS.map((lang) => ({
    path: buildLangPath(lang, path),
    element,
  }));

const indexElement = (
  <Suspense fallback={<PageLoading />}>
    <IndexRC />
  </Suspense>
);
const labsElement = (
  <Suspense fallback={<PageLoading />}>
    <Labs />
  </Suspense>
);
const notFoundElement = (
  <Suspense fallback={<PageLoading />}>
    <NotFoundRC />
  </Suspense>
);

const router = createBrowserRouter([
  {
    path: route_map.entry,
    element: <LayoutRC />,
    children: [
      ...withLanguages("", indexElement),
      { path: "*", element: notFoundElement },
    ],
    errorElement: <ErrorBoundary />,
  },
  ...withLanguages("/labs", labsElement),
  {
    path: "*",
    element: <LayoutRC />,
    children: [{ path: "*", element: notFoundElement }],
  },
]);

export default router;
